import {css} from "styled-components";
import {getColor} from "@/pipes/theme.pipe";

const colorOptions = {
    primary: css`
        --button-first-color: ${getColor('primary')};
        --button-second-color: ${getColor('natural', '900')};
    `,
    secondary: css`
        --button-first-color: ${getColor('secondary')};
        --button-second-color: ${getColor('natural', '900')};
    `,
    secondaryDark: css`
        --button-first-color: ${getColor('secondary', '100')};
        --button-second-color: ${getColor('natural', '900')};
    `,
    dark: css`
        --button-first-color: ${getColor('natural', '100')};
        --button-second-color: ${getColor('natural', '900')};
    `,
    light: css`
        --button-first-color: ${getColor('natural', '900')};
        --button-second-color: ${getColor('primary')};
    `,
    secondaryLight: css`
        --button-first-color: ${getColor('natural', '450')};
        --button-second-color: ${getColor('natural', '100')};
    `,
    danger: css`
        --button-first-color: ${getColor('danger')};
        --button-second-color: ${getColor('natural', '900')};
    `,
    blue: css`
        --button-first-color: transparent;
        --button-second-color: ${getColor('secondary')};
    `,
    black: css`
        --button-first-color: transparent;
        --button-second-color: ${getColor('primary')};
    `,
}

export const getColorStyles = ({color}) => colorOptions[color] ?? colorOptions['secondary']
